import { Settings } from "lucide-react";
import React, { useMemo } from "react";

interface TemplateDetailsSectionProps {
  template: any;
}

export const TemplateDetailsSection: React.FC<TemplateDetailsSectionProps> = ({
  template,
}) => {
  // Memoize detail fields
  const detailFields = useMemo(
    () => [
      {
        label: "TEMPLATE TYPE",
        value: template?.templateType ?? "NA",
        key: "templateType",
      },
      {
        label: "BACK PRINT",
        value: template?.backPrint ?? "NA",
        key: "backPrint",
      },
      {
        label: "CATEGORY",
        value: template?.category ?? "NA",
        key: "category",
      },
      {
        label: "PAPER SIZE",
        value: template?.pageData?.size ?? "NA",
        key: "paperSize",
      },
    ],
    [template]
  );

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Settings className="h-5 w-5 text-blue-600" />
        <h2 className="text-lg font-semibold text-blue-600">
          TEMPLATE DETAILS
        </h2>
      </div>

      {/* Grid of detail fields */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        {detailFields.map((field) => (
          <div key={field.key}>
            <p className="text-xs font-medium text-gray-500 mb-1">
              {field.label}
            </p>
            <p className="text-sm font-medium text-gray-900">
              {field.value || "N/A"}
            </p>
          </div>
        ))}
      </div>

      {/* Description section */}
      <div>
        <p className="text-xs font-medium text-gray-500 mb-2">DESCRIPTION</p>
        <p className="text-sm text-gray-900">
          {template?.description || "No description provided"}
        </p>
      </div>
    </div>
  );
};
